"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* babel-plugin-inline-import './icons/arrow-white.svg' */
var ArrowWhite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjAzNjc2IDAuOTAzMjE0TDQuOTgxNDEgMy44NDc1M0w3Ljk3MDM2IDAuOTYxNTVDOC4yMTM1MiAwLjcyNjczMyA4LjU5ODMgMC43MzA3MDkgOC44MzM0NCAwLjk3NDE5N0M5LjA2Njk0IDEuMjE2IDkuMDYxOTMgMS41OTk2NSA4LjgxNTk2IDEuODM3MTlMNS40MzIzNCA1LjEwNDcxQzUuMjg3MyA1LjI0NDc4IDUuMDkxODYgNS4yOTk4OCA0LjkwNzg2IDUuMjY5ODdDNC43NjEyMSA1LjI2Mzc0IDQuNjE1OTIgNS4yMDM4OCA0LjUwMjA5IDUuMDkwMDRMMS4xNzYwMSAxLjc2Mzk3QzAuOTM2OTg2IDEuNTI0OTQgMC45MzQyNDYgMS4xNDAxNCAxLjE3MzU5IDAuOTAwNzk2QzEuNDExMjggMC42NjMxMDYgMS43OTQ5NyAwLjY2MTQyIDIuMDM2NzYgMC45MDMyMTRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
/* babel-plugin-inline-import './icons/arrow-black.svg' */
var ArrowBlack = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjAzNjc2IDAuOTAzMjE0TDQuOTgxNDEgMy44NDc1M0w3Ljk3MDM2IDAuOTYxNTVDOC4yMTM1MiAwLjcyNjczMyA4LjU5ODMgMC43MzA3MDkgOC44MzM0NCAwLjk3NDE5N0M5LjA2Njk0IDEuMjE2IDkuMDYxOTMgMS41OTk2NSA4LjgxNTk2IDEuODM3MTlMNS40MzIzNCA1LjEwNDcxQzUuMjg3MyA1LjI0NDc4IDUuMDkxODYgNS4yOTk4OCA0LjkwNzg2IDUuMjY5ODdDNC43NjEyMSA1LjI2Mzc0IDQuNjE1OTIgNS4yMDM4OCA0LjUwMjA5IDUuMDkwMDRMMS4xNzYwMSAxLjc2Mzk3QzAuOTM2OTg2IDEuNTI0OTQgMC45MzQyNDYgMS4xNDAxNCAxLjE3MzU5IDAuOTAwNzk2QzEuNDExMjggMC42NjMxMDYgMS43OTQ5NyAwLjY2MTQyIDIuMDM2NzYgMC45MDMyMTRaIiBmaWxsPSIjMUMxQTE4Ii8+Cjwvc3ZnPgo=";
var Collapsible = function Collapsible(_ref) {
  var header = _ref.header,
    headerClassName = _ref.headerClassName,
    children = _ref.children,
    contentClassName = _ref.contentClassName,
    className = _ref.className,
    _ref$arrowStyle = _ref.arrowStyle,
    arrowStyle = _ref$arrowStyle === void 0 ? 'white' : _ref$arrowStyle,
    arrowClassName = _ref.arrowClassName,
    onHeaderSizeChange = _ref.onHeaderSizeChange,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded;
  var wrapperRef = (0, _react.useRef)(null);
  var contentWrapper = (0, _react.useRef)(null);
  var content = (0, _react.useRef)(null);
  var collapseArrow = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(isExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var headerRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    childrenHeight = _useState4[0],
    setChildrenHeight = _useState4[1];
  // this value prevents useEffect's logic triggering on the first render
  // as the Collapsible is already expanded/collapsed after useLayoutEffect
  var firstRender = (0, _react.useRef)(true);
  var setContentMaxHeight = function setContentMaxHeight(height) {
    if (contentWrapper.current) {
      contentWrapper.current.style.maxHeight = "".concat(height, "px");
    }
  };
  var rotateArrow = function rotateArrow(element, value) {
    element.style.transform = "rotate(".concat(value, "deg)");
  };
  var collapseContent = function collapseContent(element) {
    setContentMaxHeight(0);
    if (element) {
      rotateArrow(element, 0);
    }
  };
  var expandContent = function expandContent(element, height, deg) {
    setContentMaxHeight(height);
    if (element) {
      rotateArrow(element, deg);
    }
  };
  (0, _react.useLayoutEffect)(function () {
    var arrow = collapseArrow.current;
    var header = headerRef.current;
    var contentEl = content.current;
    if (header) {
      var _header$getBoundingCl = header.getBoundingClientRect(),
        width = _header$getBoundingCl.width;
      if (width) {
        onHeaderSizeChange === null || onHeaderSizeChange === void 0 ? void 0 : onHeaderSizeChange({
          width: width
        });
      }
    }
    if (contentEl) {
      var _contentEl$getBoundin = contentEl.getBoundingClientRect(),
        height = _contentEl$getBoundin.height;
      setChildrenHeight(height);
      if (!isOpen) {
        collapseContent(arrow);
      } else {
        expandContent(arrow, height, 180);
      }
    }
  }, []);
  var setIsOpenState = function setIsOpenState(value) {
    children && setIsOpen(value);
  };
  (0, _react.useEffect)(function () {
    if (!firstRender.current) {
      if (isExpanded) {
        var arrow = collapseArrow.current;
        expandContent(arrow, childrenHeight, 180);
        setIsOpenState(true);
      } else {
        var _arrow = collapseArrow.current;
        collapseContent(_arrow);
        setIsOpenState(false);
      }
    }
    firstRender.current = false;
  }, [isExpanded]);
  var handleClick = function handleClick() {
    var arrow = collapseArrow.current;
    if (isOpen) {
      collapseContent(arrow);
      setIsOpenState(false);
    } else {
      expandContent(arrow, childrenHeight, 180);
      setIsOpenState(true);
    }
  };
  var handleKeyPress = function handleKeyPress(event) {
    if (children && event.key === 'Enter') {
      setIsOpenState(!isOpen);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    ref: wrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: headerRef,
    "aria-expanded": isOpen,
    onKeyDown: handleKeyPress,
    tabIndex: 0,
    onClick: handleClick,
    role: "button",
    className: (0, _classnames.default)('Collapsible_header', headerClassName)
  }, typeof header === 'string' ? /*#__PURE__*/_react.default.createElement("p", null, header) : header, children && /*#__PURE__*/_react.default.createElement("img", {
    ref: collapseArrow,
    alt: "Arrow icon",
    src: arrowStyle === 'white' ? ArrowWhite : ArrowBlack,
    className: (0, _classnames.default)('Collapsible_header_arrow', arrowClassName)
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: contentWrapper,
    className: (0, _classnames.default)('Collapsible_contentWrapper', contentClassName)
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": !isOpen,
    ref: content
  }, children)));
};
var _default = Collapsible;
exports.default = _default;